module.exports = __webpack_public_path__ + "img/gif-resetpass (2).78ea22cc.gif";